var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrain2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0072 50.0092C22.7462 53.2242 25.0689 51.3306 29.2484 49.1951C32.0332 47.0143 34.3415 42.5298 27.2835 36.9843C17.1529 29.0245 17.7361 44.5778 10.5 33C8.22219 29.3555 8.10934 27.8266 8.64047 27.2846C7.88295 27.038 6.88059 26.6676 5.57514 26.1301C-6.72631 21.0648 9.91675 22.5118 7.74591 10.9342C5.57506 -0.643523 12.8112 8.03916 20.0474 2.25024C27.2835 -3.53867 28.0072 13.1048 32.3488 5.14508C36.6904 -2.81468 41.0322 12.3812 40.3086 15.2757C39.5849 18.1701 38.1377 21.7882 46.8211 22.5118C55.5045 23.2354 49.7156 26.8535 48.2683 39.8786C46.8437 52.7002 41.2121 42.3828 28.6124 49.6497C28.4085 49.7824 28.2056 49.9023 28.0072 50.0092Z",
    fill: "url(#paint0_linear_40495_5268)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 46.8045C36.9171 42.704 17.5871 56.377 28.0072 50.0092M28.0072 50.0092C41.0323 42.0494 46.8211 52.9036 48.2683 39.8786C49.7156 26.8535 55.5045 23.2354 46.8211 22.5118C38.1377 21.7882 39.5849 18.1701 40.3086 15.2757C41.0322 12.3812 36.6904 -2.81468 32.3488 5.14508C28.0072 13.1048 27.2835 -3.53867 20.0474 2.25024C12.8112 8.03916 5.57506 -0.643523 7.74591 10.9342C9.91675 22.5118 -6.72631 21.0648 5.57514 26.1301C17.8766 31.1954 3.26385 21.4222 10.5 33C17.7361 44.5778 17.1529 29.0245 27.2835 36.9843C35.388 43.3521 31.1428 48.3208 28.0072 50.0092Z",
    stroke: "#EE8445",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 25.987C14.297 24.3534 15.9682 22.1348 17.4494 21.4668C19.1776 20.6874 20.2953 20.917 21.7842 21.9096",
    stroke: "#EE8445",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1669 35.0107C35.9961 36.458 37.8415 39.118 39.0777 40.2829C39.8644 41.0241 40.5956 41.8586 41.7239 41.9612C43.4596 42.119 44.4664 41.2676 45.2763 39.8504",
    stroke: "#EE8445",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7179 40.2524C30.6204 38.8864 29.6866 36.2433 30.615 35.0217C31.2881 34.136 32.8878 32.8389 34.054 32.8389",
    stroke: "#EE8445",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3026 13.3457C32.5148 14.3641 33.2453 15.2685 33.6103 16.2493C34.0094 17.322 34.7375 18.5856 35.8652 19.05C36.516 19.318 37.8628 18.7383 37.8628 17.9792",
    stroke: "#EE8445",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5489 17.2116C34.7621 15.3641 35.1462 12.5781 37.5143 12.5781",
    stroke: "#EE8445",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_40495_5268",
    x1: 26.25,
    y1: 1,
    x2: 26.25,
    y2: 73.0171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8D8B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E4E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrain2);
export default __webpack_public_path__ + "static/media/brain-2.5738f1d4b63ba35695487625bb501e1d.svg";
export { ForwardRef as ReactComponent };